import React, { useState } from 'react'
import blueLogo from '../../assets/img/cell-logo.png'
import whiteLogo from '../../assets/img/logo-white.png'
import { Img } from '../../components/Img'
import { Heading } from '../../components/Heading'
import MegaMenu1 from '../../components/MegaMenu1'
import menu from '../../assets/img/icon/menu.png'
import menu_blue from '../../assets/img/icon/menu_blue.png'
import { useNavigate } from 'react-router-dom'
import d from '../../assets/img/icon/q-4.png'
import dna from '../../assets/img/icon/q-3.png'
import exc from '../../assets/img/icon/q-2.png'
import right from '../../assets/img/icon/right.png'
import call from '../../assets/img/icon/call.png'
import door from '../../assets/img/icon/door.png'
import down_blue from '../../assets/img/icon/down-blue.png'
import down_white from '../../assets/img/icon/down-white.png'

export default function Header ({ color = 'white', gradientColor = '' }) {
  const [menuOpen, setMenuOpen] = useState(false)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [megaMenuOpen, setMegaMenuOpen] = useState(true)
  const navigate = useNavigate()
  const [isHovered, setIsHovered] = useState(false)
  const handleMenu = menu => {
    navigate(`/${menu}`)
    window.scrollTo(0, 0)
  }

  const handleLogoClick = () => {
    navigate('/')
    window.scrollTo(0, 0)
  }

  const callContact = () => {
    navigate('/contact')
    window.scrollTo(0, 0)
  }

  const callAbout = () => {
    navigate('/about')
    window.scrollTo(0, 0)
  }

  const callNews = () => {
    navigate('/news')
    window.scrollTo(0, 0)
  }

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen)
  }

  const openSubMenu = () => {
    setMegaMenuOpen(!megaMenuOpen)
  }

  const data1 = [
    {
      userImage: exc,
      title: 'Эсийн банк',
      description:
        'Хүйн цус болон хүйн эд нь үүдэл эсийн хосгүй эх үүсвэр бөгөөд эдгээр эсүүдийг ирээдүйд төрөл бүрийн өвчнийг эмчлэхэд ашиглах боломжтой. ',
      menu: 'cellbank'
    },
    {
      userImage: dna,
      title: 'Эсийн эмчилгээ',
      description:
        'Хүний биеийн бүтэц, үйл ажиллагааны үндсэн нэгж болох эс нь байгалиас заяасан орлуулшгүй үнэтэй эмчилгээний эх үүсвэр юм.',
      menu: 'therapy'
    },
    {
      title: 'Генетик шинжилгээ',
      description:
        'Хүн анх төрөхдөө зарим төрлийн хавдрын эрсдэлээ удмын мэдээлэлдээ тээж ирдэг.',
      userImage: d,
      menu: 'genetic'
    }
  ]

  return (
    <div className={`text-white  ${gradientColor} rounded-2xl px-5`}>
      <header
        className={` relative flex items-center justify-between py-4 px-16  maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto mobile:px-5`}
        style={{
          boxShadow: '0px 4px 6px -3px rgba(0, 0, 0, 0.1)'
        }}
      >
        <div className='flex items-center '>
          <Img
            src={color === 'white' ? whiteLogo : blueLogo}
            alt='Header Logo'
            className='h-12 w-auto cursor-pointer'
            onClick={handleLogoClick}
          />
          {/* Mobile Menu Icon */}
          <button
            className='lg:hidden ml-4 absolute right-5'
            onClick={toggleMobileMenu}
          >
            <img
              src={color === 'white' ? menu : menu_blue}
              className='h-10 w-10 text-white'
              alt='22'
            />
          </button>

          {/* Desktop Menu */}
          <ul className='ml-8 hidden lg:flex items-center gap-12'>
            <p className='text-white/55'>|</p>
            {/* negtgeh glancing */}
            <li
              onMouseEnter={() => {
                setMenuOpen(true)
                setIsHovered(true)
              }}
              onMouseLeave={() => {
                setMenuOpen(false)
                setIsHovered(false)
              }}
              className='relative cursor-pointer'
            >
              <div
                className={`flex items-center py-1 gap-2 ${
                  color === 'white' ? 'text-white' : 'text-[#215998]'
                }`}
                style={{
                  backgroundColor: isHovered ? 'white' : 'transparent',
                  borderRadius: 8
                }}
              >
                <Heading
                  as='p'
                  className={`text-[14px] font-medium p-2 px-4 ${
                    color === 'white' ? 'text-white' : 'text-[#215998]'
                  }`}
                  style={{
                    color:
                      color === 'white' && isHovered
                        ? '#215998'
                        : color === 'white' && !isHovered
                        ? 'white'
                        : '#215998'
                  }}
                >
                  Үйлчилгээ
                </Heading>
                <img
                  src={
                    color === 'white' && isHovered
                      ? down_blue
                      : color === 'white' && !isHovered
                      ? down_white
                      : down_blue
                  }
                  alt='Down Arrow'
                  className='h-1 w-2 mr-2 hover:hidden'
                />
              </div>
              {menuOpen && <MegaMenu1 />}
            </li>

            <li>
              <a
                href='/about'
                className={`text-[14px] font-medium hover:text-white ${
                  color === 'white' ? 'text-white' : 'text-[#215998]'
                }`}
              >
                Бидний тухай
              </a>
            </li>
            <li>
              <a
                href='/news'
                className={`text-[14px] font-medium   ${
                  color === 'white' ? 'text-white' : 'text-[#215998]'
                }`}
              >
                Мэдээ
              </a>
            </li>
            <p className='text-white/55'>|</p>
          </ul>
        </div>

        {/* Mobile Menu */}
        <div
          className={`absolute top-16 left-0 right-0 w-full h-full md:hidden p-4 mt-4 ${
            mobileMenuOpen ? 'block' : 'hidden'
          }`}
          onClick={toggleMobileMenu}
        >
          <div
            className='w-full h-full flex flex-col items-center justify-start'
            style={{ borderRadius: 16 }}
            onClick={e => e.stopPropagation()}
          >
            <div className='absolute top-auto z-[99] w-full px-4'>
              <div
                className='flex gap-[1.2rem] flex-col'
                style={{
                  backgroundColor: 'white',
                  padding: 20,
                  borderRadius: 16
                }}
              >
                <ul
                  className='flex flex-col items-start gap-6 text-black w-full px-0 mb-4'
                  style={{ fontSize: 14, fontWeight: 400 }}
                >
                  <li
                    className={`flex justify-between items-center w-full ${
                      megaMenuOpen
                        ? 'bg-[#F9FAFB] border-b border-[#215998]  h-[48px]'
                        : 'border-b border-none'
                    }`}
                    onClick={openSubMenu}
                  >
                    Үйлчилгээ
                    <img
                      src={right}
                      alt='Arrow Down'
                      className='h-4 w-4 ml-20'
                      style={{
                        transform: megaMenuOpen
                          ? 'rotate(270deg)'
                          : 'rotate(0deg)',
                        transition: 'transform 0.3s ease'
                      }}
                    />
                  </li>
                  {megaMenuOpen &&
                    data1.map((item, index) => (
                      <div
                        key={index}
                        className='flex flex-row items-start gap-[1.00rem]'
                        onClick={() => handleMenu(item.menu)}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className='mt-1'>
                          <img
                            src={item.userImage}
                            alt='user'
                            className='h-4 w-6'
                          />
                        </div>
                        <div className='flex flex-col text-black'>
                          <div className='flex flex-row text-black'>
                            <p className='text-[14px] font-normal'>
                              {item.title}
                            </p>
                            {/* <p className='px-2 ml-2 text-[12px] border border-[#ABEFC6] text-[#067647] bg-[#ECFDF3] rounded-[12px]'>
                            Шинэ
                          </p> */}
                          </div>
                          {/* <p className='text-[10px] font-light'>
                          {item.description}
                        </p> */}
                        </div>
                      </div>
                    ))}
                  <li
                    className='flex justify-between items-center w-full'
                    onClick={callAbout}
                  >
                    <a href='/about' className='hover:text-blue-600'>
                      Бидний тухай
                    </a>
                    <img
                      src={right}
                      alt='Arrow Down'
                      className='h-4 w-4 ml-20'
                    />
                  </li>
                  <li
                    className='flex justify-between items-center w-full'
                    onClick={callNews}
                  >
                    <a href='/news' className='hover:text-blue-600'>
                      Мэдээ
                    </a>
                    <img src={right} alt='Arrow Down' className='h-4 w-4' />
                  </li>
                </ul>
                <div className='flex flex-col gap-4'>
                  <button
                    className='flex h-12 min-w-[64px] px-4 justify-start items-center gap-0 rounded-lg border border-[#215998] text-[#215998] text-[14px]'
                    onClick={() => {
                      navigate('/contact')
                      window.scrollTo(0, 0)
                    }}
                  >
                    <img src={call} alt='Arrow Down' className='h-4 w-4 mr-4' />
                    Холбоо барих
                  </button>
                  <button
                    className='flex h-12 min-w-[64px] px-4 justify-start items-center gap-0 rounded-lg border bg-[#215998] text-white text-[14px]'
                    // onClick={() => navigate('/signup')}
                  >
                    <img src={door} alt='Arrow Down' className='h-4 w-4 mr-4' />
                    Нэвтрэх
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Desktop Buttons */}
        <div className='lg:flex space-x-4 hidden'>
          <button
            className='flex h-12 min-w-[64px] px-4 justify-start items-center gap-0 rounded-lg border bg-white text-[#215998] text-[14px]'
            onClick={callContact}
          >
            <img src={call} alt='Arrow Down' className='h-4 w-4 mr-4' />
            Холбоо барих
          </button>
          <button
            className='flex h-12 min-w-[64px] px-4 justify-start items-center  text-sm font-medium text-white bg-[#215998] rounded-lg'
            // onClick={() => navigate('/signup')}
            disabled={true}
          >
            <img src={door} alt='Arrow Down' className='h-4 w-4 mr-4' />
            Нэвтрэх
          </button>
        </div>
      </header>
    </div>
  )
}
